import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import VariableLlista from '../commons/variableLlista';

const estilsSelectorMetadada = {
    contenidor: 'estacio-introduccio-metadades-selector-metadada-selector-contenidor',
    selector: 'estacio-introduccio-metadades-selector-metadada-selector'
};

class EstacioIntroduccioMetadadesSelectorMetadada extends Component {

    constructor(props) {
        super(props);
        this.state = { valorVariable: props.valorsPossibles ? props.valorsPossibles[0].id : null };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ valorVariable: nextProps.valorsPossibles ? nextProps.valorsPossibles[0].id : null });
    }

    render() {
        const { valorsPossibles, afegirMetadadaAGrup, idGrup } = this.props;
        const { valorVariable } = this.state;
        const variable = {id: idGrup, nom: 'Tipus', valor: valorVariable, valorsPossibles};

        return (
            <div className='estacio-introduccio-metadades-selector-metadada'>
                <VariableLlista
                    estils={estilsSelectorMetadada}
                    variable={variable}
                    onChangeValorVariable={(valor) => this.setState({ valorVariable: valor })}
                    allowClear={false} />
                <Button
                    type='primary'
                    shape='circle'
                    icon='plus'
                    disabled={valorVariable === null}
                    onClick={() => afegirMetadadaAGrup(valorVariable)}>
                </Button>
            </div>
        );
    }
}

EstacioIntroduccioMetadadesSelectorMetadada.propTypes = {
    idGrup: PropTypes.number,
    valorsPossibles: PropTypes.array,
    afegirMetadadaAGrup: PropTypes.func
};

export default EstacioIntroduccioMetadadesSelectorMetadada;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioMetadadesSelectorMetadada.js